 


// import { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// // jwtDecode ki ab zarurat nahi hai, chahe to hata dena
// // import { jwtDecode } from "jwt-decode"; 
// import "bootstrap/dist/css/bootstrap.min.css";

// function Login() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     phone: "",
//     password: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     try {
//       const res = await fetch("https://borrowhub-backend.onrender.com/api/auth/login", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       const data = await res.json();

//       if (!res.ok) {
//         setError(data.message || "Login failed");
//         setLoading(false);
//         return;
//       }

//       // 🔐 TOKEN SAVE
//       localStorage.setItem("token", data.token);
      
//       // 🔥 FIX IS HERE:
//       // Token decode mat karo. Backend se jo 'user' object aaya hai use save karo.
//       // Kyunki backend bhej raha hai: { user: { _id, name, phone... } }
//       localStorage.setItem("user", JSON.stringify(data.user));

//       alert("Login successful");
//       navigate("/home");
      
//       // Page reload kar do taaki Navbar turant update ho jaye
//       window.location.reload(); 

//     } catch (err) {
//       setError("Server error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">
//       <div className="card shadow-lg p-4 rounded-4" style={{ width: "380px" }}>

//         <div className="text-center mb-3">
//           {/* Logo agar nahi hai to text dikhega */}
//           <img src="/logo.png" alt="BorrowHub" width="70" onError={(e) => e.target.style.display='none'} />
//           <h3 className="fw-bold text-success mt-2">BorrowHub</h3>
//         </div>

//         <h4 className="text-center fw-bold mb-3">Sign In</h4>

//         {error && (
//           <div className="alert alert-danger py-2 text-center">
//             {error}
//           </div>
//         )}

//         <form onSubmit={handleSubmit}>
//           <div className="mb-3">
//             <label className="form-label">Phone</label>
//             <input
//               type="text"
//               name="phone"
//               className="form-control"
//               placeholder="Enter phone number"
//               value={formData.phone}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="mb-3">
//             <label className="form-label">Password</label>
//             <input
//               type="password"
//               name="password"
//               className="form-control"
//               placeholder="Enter password"
//               value={formData.password}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <button
//             type="submit"
//             className="btn btn-success w-100"
//             disabled={loading}
//           >
//             {loading ? "Signing in..." : "Sign In"}
//           </button>
//         </form>

//         <div className="text-center mt-3">
//           <Link to="/forgot-password" className="text-success fw-semibold">
//             Forgot password?
//           </Link>
//         </div>
          

//         <div className="text-center mt-2">
//           <span>Don't have an account? </span>
//           <Link to="/register" className="fw-semibold text-success">
//             Register
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Login;

 import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    phone: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Login failed");
        setLoading(false);
        return;
      }

      // ✅ REVERSE LOGIC: Wapas LocalStorage mein token aur user save kar rahe hain
      localStorage.setItem("token", data.token); 
      localStorage.setItem("user", JSON.stringify(data.user));

      alert("Login successful!");
      navigate("/home");
      
      // UI refresh ke liye
      window.location.reload(); 

    } catch (err) {
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  // 🎨 TERA UI (BIKUL UNTOUCHED)
  return (
    <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">
      <div className="card shadow-lg p-4 rounded-4" style={{ width: "380px" }}>

        <div className="text-center mb-3">
          <img src="/logo.png" alt="BorrowHub" width="70" onError={(e) => e.target.style.display='none'} />
          <h3 className="fw-bold text-success mt-2">BorrowHub</h3>
        </div>

        <h4 className="text-center fw-bold mb-3">Sign In</h4>

        {error && (
          <div className="alert alert-danger py-2 text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Phone</label>
            <input
              type="text"
              name="phone"
              className="form-control"
              placeholder="Enter phone number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              className="form-control"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-success w-100"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="text-center mt-3">
          <Link to="/forgot-password" title="reset password link" className="text-success fw-semibold" style={{textDecoration: "none"}}>
            Forgot password?
          </Link>
        </div>

        <div className="text-center mt-2">
          <span>Don't have an account? </span>
          <Link to="/register" className="fw-semibold text-success" style={{textDecoration: "none"}}>
            Register
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;